export enum QualificationType {
	Tertiary = 'Tertiary',
	Matric = 'Matric',
	Other = 'Other',
}
